import draggable from 'vuedraggable'
export default {
  name: 'parametrages',
  components: {
    draggable
  },
  props: [],
  data () {
    return {
      parametrages: [
        {
          "id":1,
          "libelle": "Titre",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":2,
          "libelle": "Date",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":3,
          "libelle": "Lieu de travail",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":4,
          "libelle": "Unité de travail",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":5,
          "libelle": "Effectif",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":6,
          "libelle": "Poste",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":7,
          "libelle": "Heure de début",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":8,
          "libelle": "Heure de fin",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":9,
          "libelle": "Durée",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":10,
          "libelle": "Equipe",
          "state": false,
          "hover":false,
          "editMode": false
        },
      ],

      paramDescriptifRisques:[
        {
          "id":11,
          "libelle": "Description de la tâche",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":12,
          "libelle": "Danger ou situation de risque",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":13,
          "libelle": "Illustrations (prises de photos)",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":14,
          "libelle": "Facteurs",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":15,
          "libelle": "Facteurs de risques",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":16,
          "libelle": "Risques",
          "state": false,
          "hover":false,
          "editMode": false
        },
        {
          "id":17,
          "libelle": "Personnes exposées",
          "state": false,
          "hover":false,
          "editMode": false

        },

      ],
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    consoler(){
      console.log('evor')
    },
     change(parametrage){
       parametrage.state != parametrage.state 
       console.log('cc')
     },
     moveItem(from, to) {
      if (to === -1) {
        this.removeItemAt(from);
      } else {
        this.parametrages.splice(to, 0, this.parametrages.splice(from, 1)[0]);
      }
    },
    dragFinish(to, ev) {
      this.moveItem(this.dragging, to);
      ev.target.style.marginTop = '2px'
      ev.target.style.marginBottom = '2px'
    },
    changeEditModeState(parametrage){
      parametrage.editMode = !parametrage.editMode

    }

  }
}


